import React, {createContext, useReducer, useContext} from 'react'
import {fetchAppParameters} from '../api/config'

const ConfigStateContext = createContext()
const ConfigDispatchContext = createContext()

const initialState = {
  params: {
    OrganizationName: '',
    KioskBookWorkSpace: '0',
    KioskBookMeetingSpace: '0',
    KioskCreateRequest: '0',
    KioskSearch: '0',
    SelfServiceBookWorkSpace: '0',
    SelfServiceBookMeetingSpace: '0',
    SelfServiceCreateRequest: '0',
    SelfServiceSearch: '0',
    ServiceCatalogSearch: '0',
    SelfServiceMoveRequest: '0',
    SelfServiceShowSiteMap: '1', // Site map is not implemented.
    AfternoonEndTime: '17:00:00.000',
    AfternoonStartTime: '13:00:00.000',
    MorningStartTime: '09:00:00.000',
    AbWorkplaceReservations: false, // license info
    AbSpaceHotelling: false,
    AbMoveManagement: false,
    TimelineEndTime: '20:00',
    TimelineStartTime: '08:00'
  }
}

const configReducer = (state, action) => {
  switch (action.type) {
    case 'setParameters':
      return {
        ...state,
        params: {
          ...state.params,
          ...action.payload
        }
      }

    default: {
      throw new Error(`Unhandled action type: ' ${action.type}`)
    }
  }
}

async function fetchParameters(dispatch) {
  try {
    const appParameters = await fetchAppParameters()
    dispatch({type: 'setParameters', payload: appParameters})
  } catch (error) {
    console.log(error)
  }
}

const getAvailableActions = state => {
  const {params} = state

  let kioskId = localStorage.getItem('archibus_kiosk_id')
  let isKiosk = !!kioskId
  let availableActions = {}

  if (isKiosk) {
    availableActions = {
      workingspace:
        params.KioskBookWorkSpace === '1' && params.AbSpaceHotelling,
      meetingspace:
        params.KioskBookMeetingSpace === '1' && params.AbWorkplaceReservations,
      createrequest: params.KioskCreateRequest === '1',
      search: params.KioskSearch === '1',
      moverequest: false
    }
  } else {
    availableActions = {
      workingspace:
        params.SelfServiceBookWorkSpace === '1' && params.AbSpaceHotelling,
      meetingspace:
        params.SelfServiceBookMeetingSpace === '1' &&
        params.AbWorkplaceReservations,
      createrequest: params.SelfServiceCreateRequest === '1',
      moverequest:
        params.SelfServiceMoveRequest === '1' && params.AbMoveManagement,
      search: params.SelfServiceSearch === '1'
    }
  }

  return availableActions
}

const getBookingTimes = state => {
  const {MorningStartTime, AfternoonStartTime, AfternoonEndTime} = state.params

  return {
    MorningStartTime,
    AfternoonStartTime,
    AfternoonEndTime
  }
}

/**
 * Convert the time string into a number where the minutes are rounded to the nearest half hour.
 * @param timeString
 * @returns {number}
 */
const convertTimeString = timeString => {
  let time = timeString.substring(0, 5)
  let parts = time.split(':')
  let [hours, minutes] = parts
  return parseInt(hours) + (parseInt(minutes) > 29 ? 0.5 : 0)
}

const getReservationTimes = ({params}) => ({
  start: convertTimeString(params.TimelineStartTime),
  end: convertTimeString(params.TimelineEndTime)
})

const ConfigProvider = ({children}) => {
  const [state, dispatch] = useReducer(configReducer, initialState)

  return (
    <ConfigStateContext.Provider value={state}>
      <ConfigDispatchContext.Provider value={dispatch}>
        {children}
      </ConfigDispatchContext.Provider>
    </ConfigStateContext.Provider>
  )
}

const useConfigState = () => {
  const context = useContext(ConfigStateContext)

  if (context === undefined) {
    throw new Error('useConfigState must be used within a ConfigProvider')
  }
  return context
}

const useConfigDispatch = () => {
  const context = useContext(ConfigDispatchContext)

  if (context === undefined) {
    throw new Error('useConfigDispatch must be used within a ConfigProvider')
  }
  return context
}

export {
  ConfigProvider,
  useConfigState,
  useConfigDispatch,
  fetchParameters,
  getAvailableActions,
  getBookingTimes,
  getReservationTimes
}
